import { Languages } from "../enums/languages";


export function fromDecimalNCR(input: string): string {

    if (input == null) return "";

    return input.replace(/&#(\d+);/g, (_, code) => String.fromCodePoint(Number(code)));
}

export function getLanguageLabel(language: Languages) {

    switch (language) {
        case Languages.Hebrew:
            return 'עברית';
        case Languages.Arabic:
            return 'العربية';
        case Languages.English:
            return 'English';
        default:
            return 'עברית';
    }
}